export default function BlogFormModal({ showForm, setShowForm, title, setTitle, content, setContent, saveBlog }) {
  if (!showForm) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-3xl font-bold text-white">Create New Blog</h3>
          <button
            onClick={() => setShowForm(false)}
            className="text-gray-400 hover:text-white text-2xl transition"
          >
            ✕
          </button>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-3">Blog Title</label>
            <input
              type="text"
              placeholder="Enter your blog title..."
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-purple-500/50 transition"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-3">Content (Markdown)</label>
            <textarea
              rows="12"
              placeholder="Write your blog in markdown format..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-purple-500/50 transition font-mono text-sm"
            />
          </div>

          <div className="flex gap-4">
            <button
              onClick={saveBlog}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl font-semibold text-white hover:shadow-lg hover:shadow-green-500/50 transition-all transform hover:scale-105"
            >
              ✓ Publish Blog
            </button>
            <button
              onClick={() => {
                setShowForm(false);
                setTitle('');
                setContent('');
              }}
              className="flex-1 px-6 py-3 bg-white/10 border border-white/20 rounded-xl font-semibold text-white hover:bg-white/20 transition"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
